<div class="modal solid open" [ngClass]="{v8: majorVersionNumber > 7, v7: majorVersionNumber <= 7}"  id="NetworkControllerInfo">
  <div (click)="close(false)" class="miniClose cancel icon-HamburgerAppClose"></div>
  <div class="title">DNS Records Needed to Continue {{action}}</div>
  <div class="network-issue-icon icon-Network-Failure"></div>
  <div class="subtitle">{{subtitle}}</div>

  <div class="row records-list">
    <div class="records-heading">{{header}}</div>

    <!-- headers -->
    <div class="table three">
      <div class="header borderBottom borderRight">Type</div>
      <div class="header borderBottom borderRight">Record Name</div>
      <div class="header borderBottom">Value</div>
    </div>

    <!-- rows -->
    @for (item of items; track item) {
      <div class="table three">
        <div class="borderBottom borderRight">{{ item.type }}</div>
        <div class="borderBottom borderRight">
          {{ item.recordName }}
          <i
            (click)="clickToCopy(item.recordName)"
            class="pi pi-copy copy-icon"
            title="Copy record name"
          ></i>
        </div>
        <div class="borderBottom">
          {{ item.value }}
          <i
            (click)="clickToCopy(item.value)"
            class="pi pi-copy copy-icon"
            title="Copy value"
          ></i>
        </div>
      </div>
    }
  </div>

  <div class="dns-footer">
    <div (click)="csv_export()" class="save clear" id="ExportToCsv">Export To CSV</div>
    <div class="dns-footer-actions">
      @if (showCancelButton) {
        <div (click)="close(false)" class="linkButton cancel">Oops, no get me out of here</div>
      }
      <button (click)="close(true)" class="save" id="CloseNetworkInfoButton">{{buttonLabel}}</button>
    </div>
  </div>
</div>
